export class LoggingRecord {
  class: number;
  header: string;
  payload: string = '';
  status: string;
}
